import { render, staticRenderFns } from "./DormList.vue?vue&type=template&id=e7857e04&scoped=true&"
import script from "./DormList.vue?vue&type=script&lang=js&"
export * from "./DormList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7857e04",
  null
  
)

export default component.exports